<template>
  <div class="footer" :class="{ 'mobile-layout': isMobile }">
    <!-- 左侧：GRAVITY GAME VISION 标志和版权信息 -->
    <div class="left">
      <div class="logo gravity-logo"></div>
      <p class="copyright" v-if="!isMobile">
        <cite
          >© Gravity Co.,Ltd. & LeeMyoungJin(studio DTDS) All rights
          reserved.</cite
        >
      </p>
    </div>

    <!-- 右侧：游戏评级、内容说明和服务条款 -->
    <div class="right">
      <div class="rating-block">
        <div class="rating-icon"></div>
        <div class="rating-content">
          <div class="rating-text">
            <div>本遊戲內容涉及暴力、戀愛交友</div>
            <div>本遊戲部份內容需另行支付費用</div>
            <div>請避免沉迷遊戲</div>
          </div>
          <div class="terms">
            <a
              href="https://gpassport.gnjoy.hk/center/ServicePrivacy/service?gameId=386"
              target="_blank"
              >服務條款</a
            >
            <span class="separator" v-if="!isMobile">|</span>
            <a
              href="https://gpassport.gnjoy.hk/center/ServicePrivacy/privacy?gameId=386"
              target="_blank"
              >隱私政策</a
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端版权信息 -->
    <p class="copyright mobile-copyright" v-if="isMobile">
      <cite
        >© Gravity Co.,Ltd. & LeeMyoungJin(studio DTDS) All rights
        reserved.</cite
      >
    </p>
  </div>
</template>

<script setup>
import { inject } from "vue";

const isMobile = inject("isMobile");
</script>

<style scoped lang="less">
@import "../assets/less/footer.less";
</style>
